Shopware.Service('cmsService').registerCmsElement({
    plugin: 'MoorlFoundation',
    icon: 'regular-filter',
    name: 'moorl-sidebar-filter',
    label: 'sw-cms.elements.moorl-sidebar-filter.title',
    component: 'sw-cms-el-sidebar-filter',
    configComponent: 'sw-cms-el-config-sidebar-filter',
    previewComponent: true,
    disabledConfigInfoTextKey:
        'sw-cms.elements.sidebarFilter.infoText.filterElement',
});
